import { token , getUserInfo, oneClickLogin} from './api/auth'
import { getToken, setToken, removeToken ,setOneKey ,removeOneKey} from '@/utils/auth'
import constant from "@/utils/constant";

/**
 *   历史遗留问题导致VUEX 无法扩展，
 *    如果需要使用到vuex 只能往params里面定义
 *
 */


const params = {
  state: {
    id:null,
    account: null,
    userName: null,
    merchantLevel: null,
    parentId: null,
    lastIP:null,
    lastTime:null,
    token:null,
  },
  mutations: {
    user (state, user) {
      state.id = user.id;
      state.item = user.item;
      state.parentId = user.parentId;
      state.userName = user.userName;
      state.account = user.account;
      state.merchantLevel = user.merchantLevel;
      state.lastIP = user.lastIP;
      state.lastTime = user.lastTime;
    },
    logout (state,params) {
      state.id = params;
      state.item = params;
      state.parentId = params;
      state.userName = params;
      state.account = params;
      state.merchantLevel = params;
      state.lastIP = params;
      state.lastTime = params;
      state.token = params;
      sessionStorage.removeItem("token", token);
      removeToken();
    },
    setUserName(state,name){
      state.userName = name;
    },
    refreshToken(state,token){ //刷新令牌
      state.token = token;
    },
    SET_TOKEN(state,token){
      state.token = token;
    },

  },
  getters:{
    user:state =>state
  },
  actions: {

    /**
     * 总登录处理
     * @param commit
     * @param form
     */
    login({ commit }, form){
      const platform = form.platform;
      return new Promise((resolve, reject) => {
        token(form).then(response => {
          const data = response.data;
          if (data.data.code == 0){
            const token = data.data.token;
            if (constant.constant.platform.control == platform){
              setToken(token,platform)
            }else {
              commit('SET_TOKEN', token);
              sessionStorage.setItem("token", token);
            }
            resolve(token)
          } else {
            reject(data.data.code)
          }
        }).catch(error => {
          reject(error)
        })
      })

    },
    // 部分用户拥有一件登录
    OneClickLogin({ commit}, form ){
      const platform = form.platform;
      return new Promise((resolve, reject) => {
        oneClickLogin(form).then(response => {
          const data = response.data
          if (data.data.code == 0){
            const token = data.data.token;
            if (constant.constant.platform.control == platform){
              setToken(token,platform)
            }else {
              commit('SET_TOKEN', token)
              sessionStorage.setItem("token", token);
            }
            resolve()
          } else {
            reject(data.data.code)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo({ commit, state }) {

      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
          const data = response.data.data;
          var user ={
            id : data.id,
            account : data.account,
            parentId : data.parentId,
            userName : data.name,
            merchantLevel : data.merchantLevel,
            lastTime : data.lastTime,
            lastIP : data.lastIP,
          }
          commit("user", user);
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    //  未使用方法 登出事件缺少 对应日志记录
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     *  前端登出
     * @param commit
     * @returns {Promise<any>}
     * @constructor
     */
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('logout', undefined);
        resolve()
      })
    },
  }
}

export default params



// WEBPACK FOOTER //
// ./src/store/modules/params.js